import { HttpTransport } from './http.js';
import { MockTransport } from './mock/transport.js';
import type { Transport } from './transport.js';

/**
 * Transport selection.
 *
 * `VITE_API_BASE_URL` set  → real `HttpTransport` against that origin.
 * unset (or `VITE_MOCK=1`) → in-memory `MockTransport`, so the build is demoable.
 * `VITE_MOCK=0`            → force the real transport even with an empty base (same
 *                            origin), for a console served next to its API.
 */
const baseUrl = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? '';
const mockFlag = import.meta.env.VITE_MOCK;

export const USING_MOCK = mockFlag === '1' || (mockFlag !== '0' && baseUrl === '');

export function createTransport(): Transport {
  return USING_MOCK ? new MockTransport() : new HttpTransport(baseUrl);
}

export const API_ORIGIN = USING_MOCK ? 'in-memory demo backend' : baseUrl || window.location.origin;

/**
 * The API origin, for the few callers that must build a URL themselves rather than go
 * through the typed transport: the public `/config` read the brand resolves from, and the
 * image paths that read returns.
 *
 * Empty when the console runs on its mock transport, which is the signal that there is no
 * API to ask rather than a base URL to guess at.
 */
export const API_BASE_URL = USING_MOCK ? '' : baseUrl;
